import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const ButtonWrapper = {
  display: 'flex',
  alignItems: 'center',
  height: toPx(48),
  backgroundColor: sharedStyles.Colors.Tints.NEUTRAL[7],
  borderRadius: sharedStyles.BorderRadius.MEDIUM,
  boxShadow: sharedStyles.CONTENT_BLOCK_SHADOW,
  paddingLeft: toPx(sharedStyles.Spacings.NORMAL),
  paddingRight: toPx(sharedStyles.Spacings.NORMAL),
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: sharedStyles.Colors.Tints.NEUTRAL[8],
  },
}

export const ButtonText = {
  ...sharedStyles.text,
  ...sharedStyles.textBlack,
}

export const NextStepWrapper = {
  display: 'flex',
  alignItems: 'center',
  paddingLeft: toPx(sharedStyles.NEXT_STEP_DOT_SIZE / 2),
  paddingRight: toPx(sharedStyles.NEXT_STEP_DOT_SIZE / 2 - sharedStyles.Spacings.SMALL),
  marginLeft: toPx(sharedStyles.Spacings.SMALL),
}

export const CtrText: React.CSSProperties = {
  ...sharedStyles.text,
  color: sharedStyles.Colors.PRIMARY,
  whiteSpace: 'nowrap',
  marginLeft: toPx(sharedStyles.Spacings.SMALL),
}
